import * as XLSX from "xlsx"
import { BASE_URL } from "../../../../../constants/defaultValues";

export function useBarcodeReport() {
    const generatePdfFromData = (data: any, countOfRowHaveData: number) => {
        if (!data || data.length < countOfRowHaveData) return;

        const headerRow = data[countOfRowHaveData - 1];
        const header = Object.values(headerRow);

        const pdfData = data
            .slice(countOfRowHaveData)
            .map((row: any, index: number) => {
                const headerValues = Object.values(row);
                const obj: any = { id: index + 1 };
                header.forEach((key: any, j: number) => {
                    // Remove leading and trailing spaces
                    const trimmedKey = key.split(" ").join("");
                    obj[trimmedKey] = headerValues[j];
                });
                return obj;
            });

        const getValueFromString = (valueArr: any, name: string) => {
            // find the last occurrence of the delimiter
            const lastIndex = valueArr.lastIndexOf(name);
            return lastIndex !== -1 ? valueArr.substring(lastIndex + 1) : "";
        };

        const storeName = getValueFromString(Object.values(data[0])[0], ":");
        const reportGeneratedOn = getValueFromString(
            Object.values(data[1])[0],
            "n"
        );

        pdfData.storeName = storeName;
        pdfData.reportGeneratedOn = reportGeneratedOn;

        return pdfData;
    };

    // Utility to download or fetch file and return arrayBuffer (for XLSX parsing)
    async function fetchArrayBuffer(url: string) {
        const response = await fetch(url);
        if (!response.ok) throw new Error("File fetch failed");
        return await response.arrayBuffer();
    }

    //function to triggers download using blob
    function triggerDownload(blob: Blob, filename: string) {
        const fileURL = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(fileURL);
    }

    //function to convert XLSX to JSON
    function xlsToJson(arrayBuffer: ArrayBuffer) {
        const workbook = XLSX.read(new Uint8Array(arrayBuffer), { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        return XLSX.utils.sheet_to_json(sheet);
    }

    // function to get the desired path
    function getCleanPathFromResponse(path: string | undefined): string {
        if(!path) return ''
        const fullPath = `${BASE_URL}${path}`;
        return fullPath.replace(/api\/\.\//, '');
    }
    


    return { generatePdfFromData, fetchArrayBuffer,triggerDownload,xlsToJson,getCleanPathFromResponse };
}
